import KeplerSdk from './../../keplerSdk.js'

const state = {
    brands: [],
    categories: [],
    vehicles: [],
    fuels: []
}

const mutations = {
    SET_BRAND_LIST (state, brands) {
        state.brands = brands
    },
    SET_VEHICLE_LIST (state, vehicles) {
        state.vehicles = vehicles
    },
    SET_CATEGORY_LIST (state, categories) {
        state.categories = categories
    },
    SET_FUEL_TYPE_LIST (state, fuels) {
        state.fuels = fuels
    },
}

const actions = {
    setBrandList: ({commit}, force) => {
        KeplerSdk.brands((data) => {
            commit('SET_BRAND_LIST', data)
        }, (error) => {
            alert(error)
        });
    },
    setFuelTypeList: ({commit}, force) => {
        KeplerSdk.fuelTypes((data) => {
            commit('SET_FUEL_TYPE_LIST', data)
        }, (error) => {
            alert(error)
        });
    },
    setCategoriesList: ({commit}, force) => {
        KeplerSdk.vehicleCategories((data) => {
            commit('SET_CATEGORY_LIST', data)
        }, (error) => {
            alert(error)
        });
    },
    setVehicleList: ({commit}, force) => {
        KeplerSdk.vehicles((data) => {
            commit('SET_VEHICLE_LIST', data)
        }, (error) => {
            alert(error)
        });
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/backoffice/vehiclesStore.js